import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@/components/ui/alert-dialog";
import { logo, success } from "@/constants";
import useUserStore from "@/stores/authentication/store";
import useDialogStore from "@/stores/loginDialog/store";

const LoginSuccessStatusDialog = () => {
  const { isAuthenticated } = useUserStore();

  const isLoginSuccessDialogShown = useDialogStore(
    (state) => state.isLoginSuccessDialogShown,
  );

  const setIsLoginSuccessDialogShown = useDialogStore(
    (state) => state.setIsLoginSuccessDialogShown,
  );

  return (
    <AlertDialog open={isAuthenticated && isLoginSuccessDialogShown !== true}>
      <AlertDialogContent className="bg-[linear-gradient(180deg,#092083_0%,#13204B_100%)] px-0 py-10">
        <AlertDialogHeader>
          <img src={logo} alt="logo" className="mx-auto w-[206px]" />
          <img src={success} alt="status" className="mx-auto py-4" />
          <h2 className="text-center font-inter text-3xl font-medium text-white">
            Welcome Back !
          </h2>
          <p className="py-4 text-center font-inter text-xl font-normal leading-[30px] text-[#A6A9EB] lg:px-12">
            You have successfully logged in.
          </p>
        </AlertDialogHeader>
        <AlertDialogFooter className="px-5 md:px-10">
          <AlertDialogCancel
            status="success"
            className="w-full rounded-lg text-[18px] font-normal leading-[20px]"
            onClick={() => {
              setIsLoginSuccessDialogShown(true);
            }}
          >
            OK
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
export default LoginSuccessStatusDialog;
